import React from "react";
import "./ResultMessage.css";
import botIcon from "../../assets/robot.png";

const ResultMessage = ({ result }) => {
  const isSpof = result?.result === "Spoof"? true : false;
  return (
    <div className={`result-box ${isSpof ? "fake" : "real"}`}>
      <div className="result-icon">
        <img
          src={botIcon}
          alt="Bot Icon"
          className="result-image"  />
      </div>
      <div className="result-text">
        <p className="result-message">
          {isSpof
            ?"Appears FAKE"
            : "Appears AUTHENTIC"}
        </p>
        <p className="result-confidence">
  Confidence: {result?.confidence !== undefined ? Number(result.confidence).toFixed(2) : "--"}%
</p>
      </div>
    </div>
  );
};

export default ResultMessage;
